export default __webpack_public_path__ + "static/media/profilePic-5.5f4c2d02.jpg";